import { render, staticRenderFns } from "./NewLandingPage.vue?vue&type=template&id=6397b84a&scoped=true"
import script from "./NewLandingPage.vue?vue&type=script&lang=js"
export * from "./NewLandingPage.vue?vue&type=script&lang=js"
import style0 from "./NewLandingPage.vue?vue&type=style&index=0&id=6397b84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6397b84a",
  null
  
)

export default component.exports